import { render, staticRenderFns } from "./CertificateDetailView.vue?vue&type=template&id=63ec674a&scoped=true&"
import script from "./CertificateDetailView.vue?vue&type=script&lang=js&"
export * from "./CertificateDetailView.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDetailView.vue?vue&type=style&index=0&id=63ec674a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec674a",
  null
  
)

export default component.exports